// extracted by mini-css-extract-plugin
module.exports = {"joinContainer":"join_joinContainer__2pC-W","infoContainer":"join_infoContainer__1FBkD"};